<template>
  <div class="not-found">
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Oops !
        <span class="separator" />
      </h1>
    </b-col>
    <b-col
      cols="12"
      class="contenu-not-found"
    >
      <h2>Il semblerait que cette page n'existe pas...</h2>
      <p>
        Vous pouvez retourner à l'accueil en
        <router-link :to="{ name: 'home', }">
          cliquant ici
          <i class="fas fa-home" />
        </router-link>
      </p>
    </b-col>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style lang="scss" scoped>
.contenu-not-found { padding: 0 1rem; }
</style>
